import { EXTERNAL_ID_PREFIX, LOAN_STATUS } from "../../../../constants/commonConstants";
import { PUBLIC_ROUTE } from "../../../../route.constants";
import { smoothScroll } from "@utils/helpers/smoothScroll";
import { createIdQueryString } from "../util";
import { setupLoanRoute } from "@utils/helpers/navigators";

const shouldRouteBeActive = (loanFormState) => {
  const { loanStatus } = loanFormState || {};

  return loanStatus === LOAN_STATUS.INVALID || loanStatus === LOAN_STATUS.NOT_FOUND;
}

const navigateTo = (navigate, loanFormState) => {
  navigate(PUBLIC_ROUTE.APPLICATION_NOT_FOUND + createIdQueryString(loanFormState, EXTERNAL_ID_PREFIX));
  smoothScroll();
};

export const errorRedirectNotFoundInvalid = setupLoanRoute({shouldRouteBeActive, navigateTo});